import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_phone",
  "use": "svg_phone-usage",
  "viewBox": "0 0 10 14",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 14\" id=\"svg_phone\"><path d=\"M.837.333v13.334H9.17V.333H.837Zm7.496.837v1.245H1.667V1.17h6.666Zm0 2.082v7.496H1.667V3.252h6.666Zm-6.666 9.585v-1.244H4.17v.83h1.667v-.83h2.496v1.251l-6.666-.007Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol